// removed by extract-text-webpack-plugin
module.exports = {"color_primary_purple":"#4527a0","color_dark_purple_1":"#311b92","color_white":"#ffffff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/styles.scss
// module id = 431
// module chunks = 0